export function writeLog(reason: string, logEntry: string) {
    window['common'] && window['common'].writeLog && window['common'].writeLog(reason, logEntry);
}

export function getLanguage(): number {
    return window['common'] && window['common'].getLanguage && window['common'].getLanguage();
}

export function TimeUSto5(time: string) {
    return window['common'] && window['common'].TimeUSto5 && window['common'].TimeUSto5(time);
}

export function DateUSto14(date: string) {
    return window['common'] && window['common'].DateUSto14 && window['common'].DateUSto14(date);
}

export function getIsNewGrid() {
    return window['common'] && window['common'].DateUSto14 && window['common'].getIsNewGrid();
}

export function getPriorityServer(): string {
    return (
        window['common'] &&
        window['common'].getPriorityServer &&
        window['common'].getPriorityServer()
    );
}

export function setInputLanguage(value: string) {
    window['common'] &&
        window['common'].setInputLanguage &&
        window['common'].setInputLanguage(value);
}

export function isPluginDisabled() {
    return (
        window['common'] && window['common'].isPluginDisabled && window['common'].isPluginDisabled()
    );
}

export function showOnNoPluginMessage(title: string) {
    return (
        window['common'] &&
        window['common'].showOnNoPluginMessage &&
        window['common'].showOnNoPluginMessage(title)
    );
}

export function getPriorityVersion(): number {
    return (
        window['common'] && window['common'].getServerVersion && window['common'].getServerVersion()
    );
}

export function getIsZoomInstallation() {
    return window['common'] && window['common'].getServerVersion && window['common'].getIsZoom();
}

export function getCompressedDataSet(dataSet) {
    return (
        window['common'] &&
        window['common'].getCompressedDataSet &&
        window['common'].getCompressedDataSet(dataSet)
    );
}
export function getDataSetJson(dataSet) {
    return (
        window['common'] &&
        window['common'].getDataSetJson &&
        window['common'].getDataSetJson(dataSet)
    );
}

export function getQaMode(): number {
    return window['common'] && window['common'].getQaMode && window['common'].getQaMode();
}

export function getCommandName(formCmd) {
    return (
        window['common'] &&
        window['common'].getCommandName &&
        window['common'].getCommandName(formCmd)
    );
}

export function getAPIVersion() {
    return (window as any)?.getAPIVersion();
}

export function getBaseUrl(): string {
    return (window as any)?.baseUrl;
}

export function includeScriptFile(url): HTMLElement {
    return (window as any)?.includeScriptFile(url);
}

export function isEmailValidationNeeded(): boolean {
    return (
        window['common'] &&
        window['common'].getIsEmailValidationNeeded &&
        window['common'].getIsEmailValidationNeeded()
    );
}

export function getVerifivationEmail(): string {
    return (
        window['common'] &&
        window['common'].getVerifivationEmail &&
        window['common'].getVerifivationEmail()
    );
}

export function getIsTabulaGroup(): boolean {
    return window?.['common']?.getIsTabulaGroup?.();
}

export function getBasicLanguage(): number {
    return window?.['common']?.basicLanguage;
}

export function getLoginEmail(): string {
    return window?.['common']?.getLoginEmail?.();
}
